// ============================================
// FICHAGRUPO.JS — Detalle de un grupo comercial
// ============================================

import React, { useEffect, useState } from 'react';
import PedirDatosCard from './PedirDatosCard';
import KitProveedorCard from './KitProveedorCard';
import GarantiasLista from './GarantiasLista';
import {
  API_BASE_CLI, PP, COLOR_PRINCIPAL, COLOR_OSCURO, COLOR_FONDO, COLOR_GRIS,
  COLOR_GRIS_CLARO, COLOR_BORDE,
  estiloInput, estiloBotonPrimario, estiloBotonSecundario, estiloTarjeta,
  CabeceraFicha, PuntoEstado,
} from './helpersClientes';
import { authHeaders } from '../utils/storage';
import FichaRazonSocial from './FichaRazonSocial';
import FichaSucursal from './FichaSucursal';
import ContactosAlcance from './ContactosAlcance';
import DetectorDuplicados from './DetectorDuplicados';
import BotonArchivarCliente from './BotonArchivarCliente';
import SelloAutoria from './SelloAutoria';

export default function FichaGrupo({ id, onVolver, esCelular }) {
  const [grupo, setGrupo] = useState(null);
  const [razones, setRazones] = useState([]);
  const [huerfanas, setHuerfanas] = useState([]);
  const [sucursalesPorRazon, setSucursalesPorRazon] = useState({});
  const [editandoNombre, setEditandoNombre] = useState(false);
  const [nombreTemp, setNombreTemp] = useState('');
  const [abiertas, setAbiertas] = useState({});
  const [modalRazon, setModalRazon] = useState(false);
  const [modalSucursalHuerfana, setModalSucursalHuerfana] = useState(false);
  const [modalAsignarRazon, setModalAsignarRazon] = useState(null); // sucursal a asignar
  const [razonSocialDetalle, setRazonSocialDetalle] = useState(null);
  const [sucursalDetalle, setSucursalDetalle] = useState(null);
  const [cargando, setCargando] = useState(true);

  const cargar = async () => {
    setCargando(true);
    try {
      const r = await fetch(`${API_BASE_CLI}/api/clientes/grupos/${id}`, { headers: authHeaders() }).then(x => x.json());
      if (r.ok) {
        setGrupo(r.grupo);
        setRazones(r.razones_sociales || []);
        setHuerfanas(r.sucursales_huerfanas || []);
        setNombreTemp(r.grupo.nombre);
      }
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, [id]);

  const toggleRazon = async (rsId) => {
    setAbiertas(a => ({ ...a, [rsId]: !a[rsId] }));
    if (!sucursalesPorRazon[rsId]) {
      const r = await fetch(`${API_BASE_CLI}/api/clientes/sucursales?razon_social_id=${rsId}`, { headers: authHeaders() }).then(x => x.json());
      setSucursalesPorRazon(s => ({ ...s, [rsId]: r.sucursales || [] }));
    }
  };

  const guardarNombre = async () => {
    if (!nombreTemp.trim() || nombreTemp === grupo.nombre) {
      setEditandoNombre(false);
      setNombreTemp(grupo.nombre);
      return;
    }
    await fetch(`${API_BASE_CLI}/api/clientes/grupos/${id}`, {
      method: 'PATCH',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ nombre: nombreTemp.trim() }),
    });
    setEditandoNombre(false);
    cargar();
  };

  if (razonSocialDetalle) {
    return <FichaRazonSocial id={razonSocialDetalle} onVolver={() => { setRazonSocialDetalle(null); cargar(); }} esCelular={esCelular} />;
  }
  if (sucursalDetalle) {
    return <FichaSucursal id={sucursalDetalle} onVolver={() => { setSucursalDetalle(null); cargar(); }} esCelular={esCelular} />;
  }

  if (cargando || !grupo) {
    return (
      <div style={{ fontFamily: PP, padding: 40, textAlign: 'center', color: COLOR_GRIS_CLARO }}>
        Cargando grupo (cliente)…
      </div>
    );
  }

  const totalSucursales = razones.reduce((acc, rs) => acc + (rs.sucursales_count || 0), 0);

  return (
    <div style={{ fontFamily: PP, background: COLOR_FONDO, minHeight: '100%', color: COLOR_GRIS }}>
      <CabeceraFicha
        volver={onVolver}
        titulo={
          editandoNombre
            ? <input autoFocus style={{ ...estiloInput, fontSize: 18, fontWeight: 700 }}
                value={nombreTemp}
                onChange={(e) => setNombreTemp(e.target.value)}
                onBlur={guardarNombre}
                onKeyDown={(e) => { if (e.key === 'Enter') guardarNombre(); }} />
            : <span onClick={() => setEditandoNombre(true)} style={{ cursor: 'pointer' }} title="Click para editar">{grupo.nombre}</span>
        }
        subtitulo={`Grupo (cliente) · ${razones.length} razón${razones.length === 1 ? '' : 'es'} social${razones.length === 1 ? '' : 'es'} · ${totalSucursales} sucursal${totalSucursales === 1 ? '' : 'es'}`}
        estado={grupo.estado}
      />

      <div style={{ padding: esCelular ? 16 : 24, display: 'grid', gap: 16 }}>
        {/* Árbol de razones sociales */}
        <div style={estiloTarjeta}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_OSCURO }}>Razones sociales</div>
            <button style={estiloBotonPrimario} onClick={() => setModalRazon(true)}>+ Razón Social</button>
          </div>
          {razones.length === 0 && (
            <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, padding: '8px 0' }}>
              Aún no hay razones sociales en este grupo (cliente).
            </div>
          )}
          <div style={{ display: 'grid', gap: 6 }}>
            {razones.map(rs => (
              <div key={rs.id}>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
                  background: COLOR_FONDO, borderRadius: 8,
                }}>
                  <span onClick={() => toggleRazon(rs.id)} style={{ cursor: 'pointer', fontSize: 12, color: COLOR_GRIS_CLARO, width: 14 }}>
                    {abiertas[rs.id] ? '▾' : '▸'}
                  </span>
                  <span style={{ fontSize: 16 }}>🏢</span>
                  <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => setRazonSocialDetalle(rs.id)}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: COLOR_OSCURO }}>{rs.razon_social}</div>
                    <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>
                      {rs.sucursales_count || 0} sucursal{rs.sucursales_count === 1 ? '' : 'es'}
                      {rs.rfc ? ` · ${rs.rfc}` : ''}
                    </div>
                  </div>
                  <PuntoEstado estado={rs.estado} />
                </div>
                {abiertas[rs.id] && (
                  <div style={{ paddingLeft: 42, paddingTop: 6, display: 'grid', gap: 4 }}>
                    {(sucursalesPorRazon[rs.id] || []).map(s => (
                      <div key={s.id} style={{
                        display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px',
                        fontSize: 12, color: COLOR_GRIS,
                      }}>
                        <span style={{ fontSize: 14 }}>🏪</span>
                        <span style={{ flex: 1 }}>{s.nombre_interno}</span>
                        <PuntoEstado estado={s.estado} tamano={8} />
                      </div>
                    ))}
                    {(sucursalesPorRazon[rs.id] || []).length === 0 && (
                      <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, padding: '4px 10px' }}>
                        Sin sucursales aún
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Sucursales huérfanas — solo si hay */}
        {huerfanas.length > 0 && (
          <div style={{ ...estiloTarjeta, borderColor: '#f0d9b8', background: '#fffaf2' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#a86b1e' }}>
                ⚠️ Sucursales sin razón social asignada ({huerfanas.length})
              </div>
              <button style={estiloBotonPrimario} onClick={() => setModalSucursalHuerfana(true)}>+ Sucursal</button>
            </div>
            <div style={{ fontSize: 11, color: '#a86b1e', marginBottom: 10, lineHeight: 1.5 }}>
              Estas sucursales ya existen bajo este grupo (cliente) pero no podrán facturarse hasta que se vinculen a una razón social.
            </div>
            <div style={{ display: 'grid', gap: 6 }}>
              {huerfanas.map(s => (
                <div key={s.id} style={{
                  display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
                  background: '#fff', borderRadius: 8, border: `1px solid ${COLOR_BORDE}`,
                }}>
                  <span style={{ fontSize: 16 }}>🏪</span>
                  <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => setSucursalDetalle(s.id)}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: COLOR_OSCURO }}>{s.nombre_interno}</div>
                    <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, marginTop: 2 }}>
                      {[s.ciudad, s.direccion].filter(Boolean).join(' · ') || 'Sin dirección'}
                    </div>
                  </div>
                  <button
                    style={estiloBotonPrimario}
                    onClick={() => setModalAsignarRazon(s)}
                  >
                    Asignar razón social
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Si no hay huérfanas, ofrecer botón discreto para crear una cuando se necesite */}
        {huerfanas.length === 0 && (
          <div style={{ textAlign: 'right' }}>
            <button style={estiloBotonSecundario} onClick={() => setModalSucursalHuerfana(true)}>
              + Sucursal sin razón social (temporal)
            </button>
          </div>
        )}

        {/* Contactos a nivel grupo */}
        <ContactosAlcance alcance_tipo="grupo" alcance_id={id} titulo="Administradores a nivel grupo (cliente)" />

        {/* GARANTIAS (2026-09-07): certificados de este cliente, registro oficial. */}
        <div style={estiloTarjeta}>
          <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 10 }}>Garantías</div>
          <GarantiasLista filtro={{ grupo_id: id }} compacto />
        </div>
        {/* KIT DE PROVEEDOR (2026-09-08): lo que Beep entrega para darse de alta con este cliente. */}
        <KitProveedorCard cliente={{ grupo_id: id, nombre: grupo.nombre }} />
        {/* PORTAL DEL CLIENTE (2026-09-08): pedirle sus datos con un enlace temporal. */}
        <PedirDatosCard cliente={{ grupo_id: id, nombre: grupo.nombre }} />

        {/* Historial de trabajos (placeholder) */}
        <div style={estiloTarjeta}>
          <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 10 }}>Historial consolidado de trabajos</div>
          <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO }}>Se integrará en FASE 2 con reportes de servicio.</div>
        </div>
      </div>

      {modalRazon && (
        <ModalCrearRazon
          grupoId={id}
          onCerrar={() => setModalRazon(false)}
          onCreado={() => { setModalRazon(false); cargar(); }}
          onUsarExistente={(item) => { setModalRazon(false); setRazonSocialDetalle(item.id); }}
        />
      )}
      {modalSucursalHuerfana && (
        <ModalCrearSucursalHuerfana
          grupoId={id}
          onCerrar={() => setModalSucursalHuerfana(false)}
          onCreado={() => { setModalSucursalHuerfana(false); cargar(); }}
          onUsarExistente={(item) => { setModalSucursalHuerfana(false); setSucursalDetalle(item.id); }}
        />
      )}
      {modalAsignarRazon && (
        <ModalAsignarRazon
          sucursal={modalAsignarRazon}
          razones={razones}
          onCerrar={() => setModalAsignarRazon(null)}
          onAsignado={() => { setModalAsignarRazon(null); cargar(); }}
        />
      )}

      {/* AUTORIA-CLIENTES (2026-09-18): quien lo creo y quien lo toco por ultima vez.
          Lo anterior a la migracion 087 sale como "desconocido": no se le atribuye a nadie. */}
      <div style={{ padding: esCelular ? '0 16px' : '0 24px' }}>
        <SelloAutoria entidad={grupo} />
      </div>

      {/* Acciones admin discretas — solo Dirección puede archivar */}
      <div style={{ padding: esCelular ? '20px 16px 32px' : '24px 24px 40px', display: 'flex', justifyContent: 'flex-end' }}>
        <BotonArchivarCliente
          tipo="grupo" id={grupo.id} entidad={grupo}
          onArchivado={onVolver}
        />
      </div>
    </div>
  );
}

function ModalCrearRazon({ grupoId, onCerrar, onCreado, onUsarExistente }) {
  const [nombre, setNombre] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [similares, setSimilares] = useState(0);
  const crear = async () => {
    if (!nombre.trim()) return;
    setGuardando(true);
    try {
      await fetch(`${API_BASE_CLI}/api/clientes/razones-sociales`, {
        method: 'POST', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ razon_social: nombre.trim(), grupo_id: grupoId }),
      });
      onCreado();
    } finally {
      setGuardando(false);
    }
  };
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(26,58,92,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }} onClick={onCerrar}>
      <div style={{
        background: '#fff', borderRadius: 14, padding: 24, width: '100%', maxWidth: 460,
        fontFamily: PP,
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 14 }}>Nueva razón social</div>
        <label style={{ fontSize: 12, fontWeight: 600 }}>Nombre *</label>
        <input autoFocus style={estiloInput} value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej: Comercializadora del Sur S.A. de C.V." />
        <DetectorDuplicados
          tipo="razon_social"
          nombreActual={nombre}
          onSeleccionarExistente={onUsarExistente}
          onCambioResultados={setSimilares}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button style={estiloBotonSecundario} onClick={onCerrar}>Cancelar</button>
          <button style={estiloBotonPrimario} onClick={crear} disabled={!nombre.trim() || guardando}>
            {guardando ? 'Creando…' : (similares > 0 ? 'Sí, crear nueva razón social' : 'Crear')}
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalCrearSucursalHuerfana({ grupoId, onCerrar, onCreado, onUsarExistente }) {
  const [nombre, setNombre] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [similares, setSimilares] = useState(0);
  const crear = async () => {
    if (!nombre.trim()) return;
    setGuardando(true);
    try {
      await fetch(`${API_BASE_CLI}/api/clientes/sucursales`, {
        method: 'POST', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ grupo_id: grupoId, nombre_interno: nombre.trim() }),
      });
      onCreado();
    } finally {
      setGuardando(false);
    }
  };
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(26,58,92,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }} onClick={onCerrar}>
      <div style={{
        background: '#fff', borderRadius: 14, padding: 24, width: '100%', maxWidth: 460, fontFamily: PP,
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 8 }}>Nueva sucursal (temporal)</div>
        <div style={{ fontSize: 12, color: '#a86b1e', background: '#fff4e5', padding: 10, borderRadius: 6, marginBottom: 14, lineHeight: 1.4 }}>
          ⚠️ Quedará sin razón social hasta que se vincule. No podrá facturarse mientras tanto.
        </div>
        <label style={{ fontSize: 12, fontWeight: 600 }}>Nombre interno *</label>
        <input autoFocus style={estiloInput} value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej: Tlalpan" />
        <DetectorDuplicados
          tipo="sucursal"
          nombreActual={nombre}
          contextoId={grupoId}
          onSeleccionarExistente={onUsarExistente}
          onCambioResultados={setSimilares}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button style={estiloBotonSecundario} onClick={onCerrar}>Cancelar</button>
          <button style={estiloBotonPrimario} onClick={crear} disabled={!nombre.trim() || guardando}>
            {guardando ? 'Creando…' : (similares > 0 ? 'Sí, crear nueva sucursal' : 'Crear')}
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalAsignarRazon({ sucursal, razones, onCerrar, onAsignado }) {
  const [razonId, setRazonId] = useState('');
  const [guardando, setGuardando] = useState(false);
  const asignar = async () => {
    if (!razonId) return;
    setGuardando(true);
    try {
      await fetch(`${API_BASE_CLI}/api/clientes/sucursales/${sucursal.id}`, {
        method: 'PATCH', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ razon_social_id: razonId }),
      });
      onAsignado();
    } finally {
      setGuardando(false);
    }
  };
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(26,58,92,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }} onClick={onCerrar}>
      <div style={{
        background: '#fff', borderRadius: 14, padding: 24, width: '100%', maxWidth: 420, fontFamily: PP,
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 14 }}>
          Asignar razón social a "{sucursal.nombre_interno}"
        </div>
        {razones.length === 0 ? (
          <div style={{ fontSize: 13, color: COLOR_GRIS_CLARO, padding: '8px 0' }}>
            Este grupo (cliente) aún no tiene razones sociales. Crea una primero con "+ Razón Social".
          </div>
        ) : (
          <>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Razón social *</label>
            <select style={estiloInput} value={razonId} onChange={(e) => setRazonId(e.target.value)}>
              <option value="">— Selecciona —</option>
              {razones.map(rs => <option key={rs.id} value={rs.id}>{rs.razon_social}</option>)}
            </select>
          </>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button style={estiloBotonSecundario} onClick={onCerrar}>Cancelar</button>
          <button style={estiloBotonPrimario} onClick={asignar} disabled={!razonId || guardando}>
            {guardando ? 'Asignando…' : 'Asignar'}
          </button>
        </div>
      </div>
    </div>
  );
}
